// libs

import PropTypes from 'prop-types'
import classNames from 'classnames'

// components
import TransitionPanel from '@aytm/app/stats/components/transition-panel/TransitionPanel'

// styles
import style from '@aytm/app/stats/page/question-views/components/styles/QuestionBody.module.scss'

const QuestionBody = ({ children, editing, isQuestionCollapsed }) => (
  <div className={classNames(style.container, { [style.readOnly]: !editing, [style.collapsed]: isQuestionCollapsed })}>
    <TransitionPanel in={!isQuestionCollapsed}>{status => ('exited' === status ? null : children)}</TransitionPanel>
  </div>
)

QuestionBody.propTypes = {
  children: PropTypes.any,
  editing: PropTypes.bool,
  isQuestionCollapsed: PropTypes.bool
}

QuestionBody.displayName = 'QuestionBody'

export default QuestionBody
